// extracted by mini-css-extract-plugin
export default {"container":"S01_container__+Nb7i","column":"S01_column__uxpNn","left":"S01_left__j6D07","right":"S01_right__v2bZF"};